module.exports = __webpack_public_path__ + "img/star-yellow.1982b7d0.svg";